module.exports = __webpack_public_path__ + "img/Share_Twitter.5cb4ba02.svg";